// This code fetches the account prefix of the user and returns it.

import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useStoreWrapper } from "../../../../../../store/store";

const useGetAccountPrefix = (): string => {
  const user = useStoreWrapper((state) => state.user);
  const { accountUsernamePrefix } = user;

  const [userAccountPrefix, setUserAccountPrefix] = useState("");

  useEffect(() => {
    if (!accountUsernamePrefix || accountUsernamePrefix === undefined) {
      toast.error("Account prefix not set please contact admin to set it");
      setUserAccountPrefix("N/A");
    } else {
      setUserAccountPrefix(accountUsernamePrefix);
    }
  }, []);

  return userAccountPrefix;
};

export default useGetAccountPrefix;
